module.exports = __webpack_public_path__ + "img/dhl-cod.eadce23f.png";